"use client";

import Picture1 from "../images/must-experience/singapore-package-1.jpg";
import Picture2 from "../images/must-experience/singapore-package-2.jpg";
import Picture3 from "../images/must-experience/singapore-package-3.jpg";
import Picture4 from "../images/must-experience/singapore-package-4.jpg";
import Picture5 from "../images/must-experience/singapore-package-5.jpg";
import Picture6 from "../images/must-experience/singapore-package-6.jpg";
import Picture7 from "../images/must-experience/singapore-package-7.avif";
import Picture8 from "../images/must-experience/singapore-package-8.webp";
import Picture9 from "../images/must-experience/singapore-package-9.webp";

import Car from "@/public/svg/destinations/hand-picked/car.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import Activity from "@/public/svg/destinations/hand-picked/activity.svg";
import Dot from "@/public/svg/destinations/hand-picked/dot.svg";

import HorizontalTicketCard from "@/components/horizontal-ticket-card/ticket-card";
import TicketCard from "@/components/ticket-card/ticket-card";
import Title from "@/components/title/Title";

import "@/styles/common/swiper.scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss";

import "@/sections/common/horizontal-card/horizontal-card.scss";

const Honeymoon = [

    {
        name: "Fun-Filled 5N Singapore Tour for Kids and Families from Chennai",
        picture: Picture9,
        location: "5N Singapore",
        price: "₹79,499",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "5 Star Hotels",
            },
            {
                icon: Activity,
                title: "10 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Unveil the History and Charm of Chinatown",
            },
            {
                icon: Dot,
                title: "Experience Nature Up Close at Singapore Zoo",
            },
            {
                icon: Dot,
                title: "Enjoy Magic After Dark at Wings of Time",
            },
            {
                icon: Dot,
                title: "Discover Marine Marvels at SEA Aquarium",
            },
            
            
            
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Recommended",
                color: "#25d366",
            },
        ],
    },
   
    {
        name: "Budget Friendly 3N Singapore Tour Package from Chennai",
        picture: Picture1,
        location: "3N Singapore",
        price: "₹32,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "6 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Discover a floral wonderland at Gardens by The Bay",
            },
            {
                icon: Dot,
                title: "Explore the best of Singapore with a city tour",
            },
            {
                icon: Dot,
                title: "Experience endless fun on Sentosa Island",
            },
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Adventure-Packed 4N Singapore Packages from Chennai",
        picture: Picture4,
        location: "4N Singapore",
        price: "₹43,999",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience Lush Serenity at Cloud Forest",
            },
            {
                icon: Dot,
                title: "Enjoy Breathtaking Views on the Cable Car",
            },
            {
                icon: Dot,
                title: "Unleash the Fun at Adventure Cove Waterpark",
            },
            {
                icon: Dot,
                title: "Jump Into Adventure at Universal Studios",
            },
            
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Best-Selling",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Exciting 3N Singapore Tour Packages from Chennai",
        picture: Picture2,
        location: "3N Singapore",
        price: "₹39,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "6 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience the Thrill of Singapore’s Night Safari",
            },
            {
                icon: Dot,
                title: "Create Memories at Universal Studios",
            },
            {
                icon: Dot,
                title: "Wander Through Wonder at Jewel Canopy Park",
            },
            
            
            
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
   
 
    {
        name: "Best-Value 4N Singapore Getaway from Chennai",
        picture: Picture6,
        location: "4N Singapore",
        price: "₹65,499",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "5 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Explore Wildlife Wonders at Singapore Zoo",
            },
            {
                icon: Dot,
                title: "Get Ready for Thrills at Universal Studios",
            },
            {
                icon: Dot,
                title: "Explore the best of Singapore with a city tour",
            },
            {
                icon: Dot,
                title: "Feel the Rush on the Skyline Luge Ride",
            },
        
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Best 5N Singapore Tour Package from Chennai",
        picture: Picture7,
        location: "5N Singapore",
        price: "₹55,999",
        type: "6 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "10 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience the Excitement at Universal Studios",
            },
            {
                icon: Dot,
                title: "Enjoy the Best of Sentosa Island",
            },
            {
                icon: Dot,
                title: "Capture the Essence of Singapore in a Half-Day Tour",
            },
            {
                icon: Dot,
                title: "Step into a World of Birds at Bird Paradise",
            },
            
            
            
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Luxurious 3N Singapore Trips from Chennai",
        picture: Picture3,
        location: "3N Singapore",
        price: "₹23,199",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "5 Star Hotels",
            },
            {
                icon: Activity,
                title: "6 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience Luxury at Marina Bay Sands",
            },
            {
                icon: Dot,
                title: "Discover Thrills at Universal Studios Singapore",
            },
            {
                icon: Dot,
                title: "Meet the Wild at Singapore Zoo",
            },
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
   
    {
        name: "Spectacular 5N Singapore Tour Packages from Chennai",
        picture: Picture8,
        location: "5N Singapore",
        price: "₹59,999",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "10 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Step Into a Green Paradise at Gardens by the Bay",
            },
            {
                icon: Dot,
                title: "Escape to Fun and Sun on Sentosa Island",
            },
            {
                icon: Dot,
                title: "Make a Splash at Adventure Cove Waterpark",
            },
            {
                icon: Dot,
                title: "Discover Singapore’s Top Attractions in Half a Day",
            },
           
            
            
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Best-Selling",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Adventure-Filled 4N Singapore Packages from Chennai",
        picture: Picture5,
        location: "4N Singapore",
        price: "₹51,999",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience the Mystique of Night Safari",
            },
            {
                icon: Dot,
                title: "Enjoy the Fun Rides at Universal Studios",
            },
            {
                icon: Dot,
                title: "Uncover the Splendor of Bird Paradise",
            },
            {
                icon: Dot,
                title: "Capture the Magic of Merlion Park",
            },
            
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Best-Selling",
                color: "#25d366",
            },
        ],
    },
   

];

const HorizontalCard = () => {
    return (
        <section className="horizontal-card-section py-10 md:py-20">
            <div className="horizontal-card-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Top Singapore Tour Packages from Chennai" />
                <div className="horizontal-card-wrapper flex flex-col gap-14">
                    {Honeymoon.map((h, index) => {
                        return <HorizontalTicketCard key={index} {...h} />;
                    })}
                </div>
            </div>
        </section>
    );
};

export default HorizontalCard;
